import React, { memo } from 'react';
import { components as reactSelectComponents } from 'react-select';

import WarningPopoverIcon from './WarningPopoverIcon';

const UomSingleValue = memo(function UomSingleValue({ lineUomInactive, ...props }) {
    const { data } = props;
    const showInactiveWarning = lineUomInactive || data?.__isInactive;
    if (!showInactiveWarning) {
        return (
            <reactSelectComponents.SingleValue {...props}>
                <span>{data?.label}</span>
            </reactSelectComponents.SingleValue>
        );
    }
    return (
        <reactSelectComponents.SingleValue {...props}>
            <span className="fm-uom-cell__selected-inactive">
                <span className="fm-uom-cell__selected-inactive-label">{data?.label}</span>
                <WarningPopoverIcon />
            </span>
        </reactSelectComponents.SingleValue>
    );
});

export default UomSingleValue;
